import mavlink from './mavlink';

const messageSet = {
  mavlink,
};

export default messageSet;
